import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = 
[
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: 'https://spockftm.borgswap.exchange',
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://spookyswap.finance/swap?outputCurrency=0xE2463256E69E4C86345DC32e2FFED3283b0022e8'
      },
      {
        label: 'Add Liquidity',
        href: 'https://spookyswap.finance/add/FTM/0xE2463256E69E4C86345DC32e2FFED3283b0022e8'
      }
    ]
  },
  {
    label: 'Farms',
    icon: 'FarmIcon',
    href: './Farms',
  },
  {
    label: 'Staking',
    icon: 'PoolIcon',
    href: './Stake',
  },
  {
    label: 'Spock Pools',
    icon: 'GroupsIcon',
    href: './Pools',
  },
  {
    label: "Security Audit",
    icon: 'HelmetIcon',
    href: "https://github.com/TechRate/Smart-Contract-Audits/blob/main/BorgSwap.pdf",
  },
  {
    label: 'Info',
    icon: 'InfoIcon',
    items: [
      {
        label: 'Spock Contract',
        href: 'https://ftmscan.com/token/0xe2463256e69e4c86345dc32e2ffed3283b0022e8',
      },
      {
        label: 'MasterSpock Contract',
        href: 'https://ftmscan.com/address/0xC8FF977ee4e5EdA2D650C0e2706995a1DbB4926b#code',
      },
    ],
  },
  {
    label: 'More',
    icon: 'MoreIcon',
    items: [
      {
        label: "Blog",
        href: "https://medium.com/theborgtoken",
      },
      {
        label: "Documentation",
        href: "https://ftmdocs.borgswap.exchange",
      },
      {
        label: "Github",
        href: "https://github.com/locutusofborg111",
      },
      {
        label: 'Roadmap',
        href: 'https://borgswap.exchange/roadmap',
      },
    ],
  },
]

export default config
